import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const [currentTheme, setCurrentTheme] = useState('dim');

  useEffect(() => {
    const checkTheme = () => {
      const theme = localStorage.getItem('theme') || 'dim';
      setCurrentTheme(theme);
    };
    checkTheme();
    window.addEventListener('storage', checkTheme);
    const interval = setInterval(checkTheme, 500);
    return () => {
      window.removeEventListener('storage', checkTheme);
      clearInterval(interval);
    };
  }, []);

  // Select logo based on theme
  // Logo naming: "Light" = for light backgrounds (dark logo), "Dark" = for dark backgrounds (light logo)
  const logoSrc = currentTheme === 'light' 
    ? '/Logo_Horizontal_Light_Transparent.png'  // Dark colored logo for light background
    : '/Logo_Horizontal_Dark_Transparent.png';  // Light colored logo for dark background

  return (
    <footer className="relative z-10 border-t border-border bg-muted/30">
      {/* Main Footer */}
      <div className="py-12 px-6 md:px-12 lg:px-24">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-3 gap-8 mb-12">
            {/* Brand */}
            <div className="md:col-span-2">
              <Link to="/" className="flex items-center gap-2 mb-4">
                <img 
                  src={logoSrc}
                  alt="Quantum Housing Conference"
                  className="h-10 w-auto object-contain"
                />
              </Link>
              <p className="text-muted-foreground mb-4 max-w-md">
                A Coalition of Influence & Impact. Reaching 500M+ people to solve the housing crisis. 
                Join us at Tsai Auditorium, Harvard University, April 17th, 2026.
              </p>
            </div>

            {/* Conference Links */}
            <div>
              <h4 className="font-playfair font-semibold mb-4">Conference</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/agenda" className="text-muted-foreground hover:text-foreground transition-colors">
                    Agenda
                  </Link>
                </li>
                <li>
                  <Link to="/speakers" className="text-muted-foreground hover:text-foreground transition-colors">
                    Speakers
                  </Link>
                </li>
                <li>
                  <Link to="/sponsorship" className="text-muted-foreground hover:text-foreground transition-colors">
                    Sponsorship
                  </Link>
                </li>
                <li>
                  <Link to="/signup" className="text-muted-foreground hover:text-foreground transition-colors">
                    Register
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="pt-8 border-t border-border flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="text-sm text-muted-foreground">
              © 2026 Quantum Housing Conference. Organized by Global InTech AS. All rights reserved.
            </div>
            <div className="flex items-center gap-6 text-sm text-muted-foreground">
              <a href="https://globalintech.ai/privacy" target="_blank" rel="noopener noreferrer" className="hover:text-foreground transition-colors">
                Privacy Policy
              </a>
              <a href="https://globalintech.ai" target="_blank" rel="noopener noreferrer" className="hover:text-foreground transition-colors">
                Global InTech AS
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
